import { render } from "./formItem.vue?vue&type=template&id=5d4f274c&scoped=true"
import script from "./formItem.vue?vue&type=script&lang=js"
export * from "./formItem.vue?vue&type=script&lang=js"

import "./formItem.vue?vue&type=style&index=0&id=5d4f274c&lang=scss&scoped=true"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4f274c"]])

export default __exports__